module.exports = __webpack_public_path__ + "img/KSC08871.ae0f0430.jpg";